import React from "react";
import { IdCard, Scroll, Stamp, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const solutions = [{
  title: "DFW Last Mile",
  description: "Vehicle: Flatbed | Payload: 12,000 lbs. Specialized delivery for lumber yards and stone suppliers across the Metroplex.",
  icon: IdCard,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/flatbed_lumber_delivery.png",
  href: "/FleetOperationsPage"
}, {
  title: "Southeast Regional",
  description: "Vehicle: 53ft Semi | Payload: 45,000 lbs. High-capacity logistics for bulk materials throughout the Southeast region.",
  icon: Scroll,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/semi_truck_southeast.png",
  href: "/FleetOperationsPage"
}, {
  title: "Material Logistics",
  description: "Dedicated transport solutions for construction suppliers requiring consistent fleet capacity and reliable scheduling.",
  icon: Stamp,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/bulk_materials_delivery.png",
  href: "/FleetOperationsPage"
}];
export default function OurPrintSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="13219" id="our-specialized-delivery-fleet" ref={ref} className="bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className={`mb-16 max-w-2xl transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl font-default font-extrabold uppercase tracking-tighter text-foreground sm:text-6xl mb-6">
            Our Specialized Delivery Fleet
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-default">
            Industrial-grade logistics engineered for reliability. From last-mile flatbeds to long-haul semis, 
            we provide the heavy-duty capacity your bulk material business demands.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => <Link key={i} to={solution.href} className="block h-full" data-index={i}>
              <Card className={`group relative h-full overflow-hidden border-2 border-border bg-card transition-all duration-500 hover:border-primary hover:shadow-2xl hover:-translate-y-1 rounded-sm ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <div className="absolute inset-0 z-0 bg-cover bg-center opacity-0 transition-all duration-700 ease-out group-hover:opacity-20 group-hover:scale-110" style={{
              backgroundImage: `url(${solution.image})`
            }} />

                <CardContent className="relative z-10 flex h-full flex-col justify-between p-8 sm:p-10">
                  <div className="space-y-6">
                    {}
                    <div className="text-foreground transition-colors duration-300 group-hover:text-primary">
                      <solution.icon strokeWidth={1.5} className="h-12 w-12" />
                    </div>

                    {}
                    <div className="space-y-3">
                      <h3 className="font-default text-xl font-extrabold uppercase tracking-tighter text-foreground">
                        {solution.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed font-mono text-sm">
                        {solution.description}
                      </p>
                    </div>
                  </div>

                  {}
                  <div className="mt-8 flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-primary opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-2">
                    <span>View Fleet Specs</span>
                    <ArrowRight className="h-4 w-4" />
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>

        <div className={`mt-16 flex justify-center transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Link to="#">
            <Button size="lg" className="h-12 px-10 text-base font-default font-bold uppercase tracking-widest bg-primary text-primary-foreground hover:bg-primary/90 rounded-none shadow-lg">
              Contact Dispatch
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}